'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$00245 from "./presto.types$$anon$5.js";
import * as $j_presto$002etypes$0024$0024anon$00246 from "./presto.types$$anon$6.js";
import * as $j_presto$002etypes$0024$002dCredential from "./presto.types$-Credential.js";
import * as $j_presto$002etypes$0024$002dCredential$002dKind$0024 from "./presto.types$-Credential-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Credential$$anon$3(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$Credential$$anon$3 as $c_Lpresto_types$Credential$$anon$3 };
$p = $c_Lpresto_types$Credential$$anon$3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Credential$$anon$3;
/** @constructor */
function $h_Lpresto_types$Credential$$anon$3() {
}
export { $h_Lpresto_types$Credential$$anon$3 as $h_Lpresto_types$Credential$$anon$3 };
$h_Lpresto_types$Credential$$anon$3.prototype = $p;
$p.bN = (function(str) {
  var this$3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_parser_package$();
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Parser__decode__T__Lio_circe_Decoder__s_util_Either(this$3, str, new $c_Lpresto_types$$anon$4()).afI($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_$less$colon$less$().bL);
});
$p.cAL = (function(credential) {
  try {
    var this$6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(new $j_presto$002etypes$0024$0024anon$00246.$c_Lpresto_types$$anon$6(), credential);
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Printer$().I9.vn(this$6));
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.bJ = (function(t) {
  return this.cAL(t);
});
var $d_Lpresto_types$Credential$$anon$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Credential$$anon$3, "presto.types$Credential$$anon$3", ({
  YM: 1,
  K: 1
}));
export { $d_Lpresto_types$Credential$$anon$3 as $d_Lpresto_types$Credential$$anon$3 };
/** @constructor */
function $c_Lpresto_types$Credential$() {
  this.c4m = null;
  this.c4n = false;
}
export { $c_Lpresto_types$Credential$ as $c_Lpresto_types$Credential$ };
$p = $c_Lpresto_types$Credential$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Credential$;
/** @constructor */
function $h_Lpresto_types$Credential$() {
}
export { $h_Lpresto_types$Credential$ as $h_Lpresto_types$Credential$ };
$h_Lpresto_types$Credential$.prototype = $p;
$p.a2J = (function() {
  if ((!this.c4n)) {
    this.c4m = new $c_Lpresto_types$Credential$$anon$3(this);
    this.c4n = true;
  }
  return this.c4m;
});
$p.gj = (function(x$0) {
  return new $j_presto$002etypes$0024$002dCredential.$c_Lpresto_types$Credential($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(0)), x$0.j(1), x$0.j(2), x$0.j(3), x$0.j(4), (!(!x$0.j(5))), x$0.j(6), x$0.j(7));
});
var $d_Lpresto_types$Credential$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Credential$, "presto.types$Credential$", ({
  YL: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$Credential$ as $d_Lpresto_types$Credential$ };
var $n_Lpresto_types$Credential$;
function $m_Lpresto_types$Credential$() {
  if ((!$n_Lpresto_types$Credential$)) {
    $n_Lpresto_types$Credential$ = new $c_Lpresto_types$Credential$();
  }
  return $n_Lpresto_types$Credential$;
}
export { $m_Lpresto_types$Credential$ as $m_Lpresto_types$Credential$ };
/** @constructor */
function $c_Lpresto_types$$anon$4() {
  this.c2J = null;
  this.c2B = null;
  this.c2C = false;
  this.c2K = null;
  this.c2L = false;
  this.c2O = null;
  this.c2H = null;
  this.c2I = false;
  this.c2D = null;
  this.c2E = false;
  this.c2F = null;
  this.c2G = false;
  this.c2M = false;
  this.c2N = false;
  this.c2J = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.c2O = "Credential";
}
export { $c_Lpresto_types$$anon$4 as $c_Lpresto_types$$anon$4 };
$p = $c_Lpresto_types$$anon$4.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$4;
/** @constructor */
function $h_Lpresto_types$$anon$4() {
}
export { $h_Lpresto_types$$anon$4 as $h_Lpresto_types$$anon$4 };
$h_Lpresto_types$$anon$4.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.c2J;
});
$p.L = (function() {
  if ((!this.c2C)) {
    this.c2B = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.c2C = true;
  }
  return this.c2B;
});
$p.O = (function() {
  if ((!this.c2L)) {
    this.c2K = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.c2L = true;
  }
  return this.c2K;
});
$p.E = (function() {
  return this.c2O;
});
$p.t = (function() {
  if ((!this.c2I)) {
    this.c2H = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("username", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hash", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("inherited", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("expires", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))))));
    this.c2I = true;
  }
  return this.c2H;
});
$p.M = (function() {
  if ((!this.c2E)) {
    this.c2D = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().dZ, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dKind$0024.$m_Lpresto_types$CredentialKind$().cx(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().ar, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))))));
    this.c2E = true;
  }
  return this.c2D;
});
$p.Q = (function() {
  if ((!this.c2G)) {
    this.c2F = new $j_presto$002etypes$0024$0024anon$00245.$c_Lpresto_types$$anon$5();
    this.c2G = true;
  }
  return this.c2F;
});
$p.w = (function() {
  if ((!this.c2N)) {
    this.c2M = false;
    this.c2N = true;
  }
  return this.c2M;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee28) => ((p) => \u03b4scrutinee28.gj(p)))($m_Lpresto_types$Credential$())));
});
var $d_Lpresto_types$$anon$4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$4, "presto.types$$anon$4", ({
  Yc: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$$anon$4 as $d_Lpresto_types$$anon$4 };
//# sourceMappingURL=presto.types$$anon$4.js.map
